import request from "../request";

export class SchoolService {
  
  static get = async () => {
    return await request.get(`/school`);
  };

}